const removeOrphans = () => {
    const elements = [
        '.ea-block h1',
        '.ea-block h2',
        '.ea-block h3',
        '.ea-block h4',
        '.ea-block h5',
        '.ea-block h6',
        '.ea-block p',
        '.ea-block span',
        '.ea-block a'
    ]
    Array.prototype.forEach.call(document.querySelectorAll(elements.join(',')), function(el, i){
        let string = el.innerHTML;
        el.innerHTML = string.replace(/(\s)([\S]{1,2})[\s]+/g, "$1$2&nbsp;");
    });
}

export default removeOrphans